import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';

const T = Translator.create();
export function getValidation(props?: IValidation) {

    const defaultValidation = new DefaultValidation(props);

    return Yup.object().shape({
        name: defaultValidation.GetName(),
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        // isFileUploadEmpty: defaultValidation.GetIsFileUploadEmpty(),
        activityBeginDate: defaultValidation.GetActivityBeginDate(),
        activityBeginTime: defaultValidation.GetActivityBeginTime(),
        activityEndDate: defaultValidation.GetActivityEndDate(),
        activityEndTime: defaultValidation.GetActivityEndTime(),
        datePrerequisiteActivityId: defaultValidation.GetDatePrerequisiteActivityId(),
        selectActivity: defaultValidation.GetSelectActivity(),
        isCommon: defaultValidation.GetIsCommon(),
        selectedClass: defaultValidation.GetSelectedClass(),
        completionType: defaultValidation.GetCompletionType(),
        completionCriteria: Yup.number()
        .when('completionType', {
            is: val => val === 11,
            then: Yup.number()
            .typeError(T.t('r_enter_number_validation'))
            .required(T.t('r_enter_number_validation'))
            .min(1, T.t('r_enter_valid_number_validation'))
        }),
        examQuestionCount: Yup.number()
            .required(T.t('r_enter_number_validation'))
            .min(1, T.t('r_exam_question_count_validation'))
            .max(1000, T.t('r_exam_question_count_validation')),
        repeatCount: Yup.number().when('examRepeatCountInfinity', {
            is: val => val === false,
            then: Yup.number()
            .required(T.t('r_enter_number_validation'))
            .min(1, T.t('r_exam_repeat_count_validation'))
            .max(100, T.t('r_exam_repeat_count_validation')),
            otherwise: Yup.number()
            .required(T.t('r_enter_number_validation'))
        }),
      //  customProperty5: defaultValidation.GetCustomProperty5(),
        examSessionBeginDate: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionBeginDate(),
        examSessionBeginDateTime: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionBeginDateTime(),
        examSessionEndDate: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionEndDate(),
        examSessionEndDateTime: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionEndDateTime(),
        examDurationInMinutes: defaultValidation.GetExamDurationInMinutes(),
        examShowAnswerSpecifiedDate: defaultValidation.GetExamShowAnswerSpecifiedDate(),
        examShowAnswerSpecifiedDateTime: defaultValidation.GetExamShowAnswerSpecifiedDateTime(),
        examQuestionWeights: defaultValidation.GetExamQuestionWeights(),
        prerequisiteActivityId: defaultValidation.GetPrerequisiteActivityId(),
    });
}
